import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export default (function (organisationKey, serialNumber, blockUI) {
    if (blockUI === void 0) { blockUI = true; }
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_DELETE_REMARK, { organisationKey: organisationKey, serialNumber: serialNumber });
    var request = new Request({
        method: Methods.DELETE,
        url: url,
        withCredentials: true,
        blockUI: blockUI
    });
    return request.execute();
});
